"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { CreateWaveStep } from "@/types/waves.types";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
enum CreateWaveNextStepType {
  NEXT = "NEXT",
  SAVE = "SAVE",
}
export default function CreateWaveNextStep(t0) {
  const $ = _c(17);
  const {
    disabled,
    step,
    submitting,
    onClick
  } = t0;
  let t1;
  if ($[0] !== step) {
    t1 = () => {
      if (step === CreateWaveStep.DESCRIPTION) {
        return CreateWaveNextStepType.SAVE;
      }
      return CreateWaveNextStepType.NEXT;
    };
    $[0] = step;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getStepType = t1;
  let t2;
  if ($[2] !== getStepType) {
    t2 = getStepType();
    $[2] = getStepType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [stepType, setStepType] = useState(t2);
  let t3;
  if ($[4] !== getStepType) {
    t3 = () => setStepType(getStepType());
    $[4] = getStepType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== step) {
    t4 = [step];
    $[6] = step;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== disabled || $[9] !== onClick) {
    t5 = <PrimaryButton onClicked={onClick} disabled={disabled} loading={false} padding="tw-px-6 tw-py-3">Next</PrimaryButton>;
    $[8] = disabled;
    $[9] = onClick;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onClick || $[12] !== submitting) {
    t6 = <PrimaryButton onClicked={onClick} disabled={submitting} loading={submitting} padding="tw-px-6 tw-py-3">Complete</PrimaryButton>;
    $[11] = onClick;
    $[12] = submitting;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = {
      [CreateWaveNextStepType.NEXT]: t5,
      [CreateWaveNextStepType.SAVE]: t6
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const components = t7;
  return components[stepType];
}